import { Organization } from "@src/lib/__generated/graphql.types";
import { fixImagePath } from "@src/utils/dom";
import { AssetFields, AssetFile } from "contentful";
import { ArticleJsonLd, ArticleJsonLdProps } from "next-seo";
import React from "react";

export type ArticleSchemaProps = ArticleJsonLdProps & {organization: Organization} & {};

const getImageInfo = (images: any) => {
  const image = images && images.length >= 0 ?  images[0] : undefined;
  const imageFile = image?.fields?.file as AssetFile;

  return image ?  {
    "@type": "ImageObject",
    url: fixImagePath(imageFile?.url),
    width: imageFile?.details?.image?.width,
    height: imageFile?.details?.image?.height,
  } : undefined;

}


const ArticleSchema = (props: ArticleSchemaProps) => {
  const {
    datePublished,
    dateModified,
    description,
    title,
    url,
    authorName,
    organization,
    images
  } = props;

  const image = getImageInfo(props?.images);

  const schemas = {
    "@context": "https://schema.org",
    "@type": "Article",
    url,
    wordCount: "",
    mainEntityOfPage: {
      "@type": "Webpage",
      "@id": url,
    },
    headline: title,
    image,

    datePublished: datePublished, //TODO: should be"2020-11-25T13:00:00-05:00",
    dateModified: dateModified,
    description: description,
    inLanguage: "en",
    //TODO: add publisher
    publisher: {
      "@type": "Organization",
      name: organization.name,

      logo: {
        "@type": "ImageObject",
        url:fixImagePath(organization.logo?.url || ""),
        width: organization.logo?.width || 700,
        height: organization.logo?.height || 700,
      },
    },
    author: {
      "@type": "Person",
      name: authorName
    },
    // TODO: add genre to settings
    // genre: "Medicare",
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `${JSON.stringify(schemas)}`,
        }}
      />
      {/* <ArticleJsonLd
        datePublished={datePublished}
        dateModified={dateModified}
        description={description}
        images={imageUrls}
        title={title}
        url={url}
        authorName={authorName}
        isAccessibleForFree={true}
      /> */}
    </>
  );
};

export default ArticleSchema;
/*


<script type="application/ld+json">
{
    "@type": "Article",
    "articleSection": "Insights",
    "author": {
        "@id": "https://nystudio107.com/#identity"
    },
    "copyrightHolder": {
        "@id": "https://nystudio107.com/#identity"
    },
    "copyrightYear": "2019",
    "creator": {
        "@id": "https://nystudio107.com/#creator"
    },
    "dateModified": "2022-05-19T11:30:48-04:00",
    "datePublished": "2019-05-29T08:00:00-04:00",
    "description": "Want to see a some real-world examples of JSON-LD Structured Data \"in the wild\"? This article has that, plus annotation.",
    "genre": "Technology",
    "headline": "Annotated JSON-LD Structured Data Examples",
    "image": {
        "@type": "ImageObject",
        "url": "https://nystudio107.com/img/blog/_1200x630_crop_center-center_82_none/json-ld-structured-data-in-the-wild.jpg?mtime=1558961078"
    },
    "inLanguage": "en",
    "mainEntityOfPage": "https://nystudio107.com/blog/annotated-json-ld-structured-data-examples",
    "name": "Annotated JSON-LD Structured Data Examples",
    "publisher": {
        "@id": "https://nystudio107.com/#creator"
    },
    "speakable": {
        "@type": "SpeakableSpecification",
        "cssSelector": [
            ".blog-wrapper"
        ]
    },
    "url": "https://nystudio107.com/blog/annotated-json-ld-structured-data-examples"
}
</script>


<script type="application/ld+json">
{
    "@context": "https://schema.org",
    "@type": "Article",
    "url": "https://semrush.com/blog/blog-seo/",
    "wordCount": "",
    "mainEntityOfPage": {
        "@type": "Webpage",
        "@id": "https://google.com/article"
    },
    "headline": "Blog SEO: How to Optimize Your Blog for Search Engines",
    "image": {
        "@type": "ImageObject",
        "url": "https://static.semrush.com/blog/uploads/media/c0/b1/c0b1a2b2ef6223c245bf9bf3e93f48d7/extra.png",
        "width": "885px",
        "height": "375px"
    },
    "datePublished": "2020-11-25T13:00:00-05:00",
    "dateModified": "2023-06-26T06:19:00-04:00",
    "description": "Blog SEO is the process of using SEO techniques to increase your blog‘s traffic. Here‘s how to do it.",
    "identifier": "blog/blog-seo",
    "publisher": {
        "@type": "Organization",
        "name": "Semrush",
        "logo": {
            "@type": "ImageObject",
            "url": "https://cdn.semrush.com/__static__/semrush-logo-700.jpg",
            "width": "700",
            "height": "700"
        }
    },
    "author": {
        "@type": "Person",
        "name": "Tushar Pol",
        "identifier": "203456689"
    },
    "genre": "SEO Copywriting"
}
</script>


<script type="application/ld+json">
{
    "@context": "https://schema.org",
    "@type": "Article",
    "url": {
        "url": "https://www.seniorhealthcaredirect.com/blog/special-enrollment-period"
    },
    "wordCount": "",
    "mainEntityOfPage": {
        "@type": "Webpage",
        "@id": "https://google.com/article"
    },
    "headline": {
        "title": "Understanding Special Enrollment Periods"
    },
    "datePublished": "2023-05-24T14:06:56.483Z",
    "dateModified": "2023-05-24T14:06:56.483Z",
    "description": "Discover how you can qualify for a Special Enrollment Period (SEP) which includes national emergenices and the Coronavirus COVID-19.",
    "inLanguage": "en"
}
</script>
*/
